import DescriptionPage from './DescriptionPage';
export default DescriptionPage;
